import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

const FlyoutMenuItem = (_param)=> {
    var { link , action , children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "link",
        "action",
        "children",
        "className"
    ]);
    return React__default.createElement("li", swcHelpers.extends({
        className: classnames('flyout-menu-item', className)
    }, rest), !action && link && /*#__PURE__*/ React__default.createElement("a", {
        href: link,
        className: "flyout-menu-item__link"
    }, children), action && /*#__PURE__*/ React__default.createElement("button", {
        onClick: action,
        className: "flyout-menu-item__link"
    }, children));
};
var FlyoutMenuItem$1 = FlyoutMenuItem;

export { FlyoutMenuItem$1 as default };
//# sourceMappingURL=FlyoutMenuItem.js.map
